import { APIClient } from "../api";

export default class PauseReasonService extends APIClient {

    constructor(props: any) {
        super(props);
    }
  
    async getPauseReasons(BusinessAreaId: number) {
      //  const url = "http://localhost:57454" + '/PauseReason?$orderby=Description desc&$filter=' + '(IdBusinessArea eq ' + BusinessAreaId + ' and Disabled eq 0)';
        const url = this.endpoint + '/PauseReason?$orderby=Description desc&$filter=' + '(IdBusinessArea eq ' + BusinessAreaId + ' and Disabled eq 0)';
        return (await this.api({
            method: 'get',
            url
        })).data;
       
    }
}